import '../Admonition.less';
import type { builtType } from '../plugins/remark-directive-extension-lib/remark-highlight';
import type { MdComponentIndexProps } from './type';

const pStyle = {
  minWidth: '16px',
  padding: 0,
  marginTop: 0,
  marginBottom: 0,
};
const contentStyle: React.CSSProperties = {
  width: 'fit-content',
  wordBreak: 'break-word',
  padding: 0,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: '8px',
};

export function HighLight(
  props: React.PropsWithChildren<
    {
      emojiText: string | null;
      type: (typeof builtType)[number];
      customIcon?: React.ReactNode;
    } & MdComponentIndexProps
  >,
) {
  return (
    <div
      className={'markdown-highlight markdown-highlight-' + props.type}
      data-markdown-component="x-highlight"
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <div className="flex">
        {props.emojiText ? (
          <section className="text-center" style={pStyle}>
            {props.emojiText}
          </section>
        ) : null}
        {props.customIcon ? (
          <span
            className={`markdown-highlight-${props.type}-icon inline-flex items-center justify-center`}
          >
            {props.customIcon}
          </span>
        ) : null}
        <section className="markdown-child-root flex-1" style={contentStyle}>
          {props.children}
        </section>
      </div>
    </div>
  );
}
